import React, { useRef, useEffect } from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import "mapbox-gl/dist/mapbox-gl.css";
import "./Map.css";
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const Map_mapbox = (props) => {
  const mapContainerRef = useRef(null);
  const longitude = Number(
    Array.isArray(props.coordinates)
      ? props.coordinates[0]
      : props.coordinates?.longitude
  );
  const latitude = Number(
    Array.isArray(props.coordinates)
      ? props.coordinates[1]
      : props.coordinates?.latitude
  );
  const hasValidCoordinates =
    Number.isFinite(longitude) &&
    Number.isFinite(latitude) &&
    longitude >= -180 &&
    longitude <= 180 &&
    latitude >= -90 &&
    latitude <= 90;

  // Initialize map when component mounts
  useEffect(() => {
    if (!hasValidCoordinates || !mapContainerRef.current) {
      return undefined;
    }

    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [longitude, latitude],
      zoom: 8,
    });

    const el = document.createElement("div");
    el.id = `marker-${props.coordinates?.name || "access-point"}`;
    el.className = "marker";
    new mapboxgl.Marker(el).setLngLat([longitude, latitude]).addTo(map);

    // Add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl(), "top-right");

    // Clean up on unmount
    return () => map.remove();
  }, [hasValidCoordinates, latitude, longitude, props.coordinates]);

  if (!hasValidCoordinates) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#64748b" }}>
        Este dispositivo no tiene coordenadas válidas para mostrar en el mapa.
      </div>
    );
  }

  return (
    <div
      className="map-container"
      ref={mapContainerRef}
      style={{
        height: "clamp(440px, 68vh, 640px)",
        width: "100%",
        overflow: "hidden",
      }}
    />
  );
};

export default Map_mapbox;
